/* eslint-disable react/jsx-props-no-spreading, react/prop-types, import/no-cycle */
import React from "react"
import Partnership from "./blocks/partnership"
import LatestBlock from "./blocks/latest-block"
import TitleContentList from "./blocks/title-content-list"
import ImageBanner from "./blocks/image-banner"
import CtaSlider from "./blocks/cta-slider"
import TitleContent from "./blocks/title-content"
import LandingBanner from "./blocks/landing-banner"
import ProjectArchive from "./blocks/project-archive"
import AboutBanner from "./blocks/about-banner"
import ValueBlock from "./blocks/value-block"
import PageBanner from "./blocks/page-banner"
import TitleColumnContent from "./blocks/title-column-content"
import ThankYou from "./blocks/thank-you"
import VideoEmbed from "./blocks/video-embed"
import Contact from "./blocks/contact"
import LocationList from "./blocks/location-list"
import EmptyBlock from "./blocks/empty-block"
import FeatureInfoBlock from "./blocks/feature-info-block"
import Timeline from "./blocks/timeline"
import QuoteBlock from "./blocks/quote-block"
import { useDebug, DebugPill } from "../../../plugins/gatsby-plugin-atollon"
import { Location } from "@reach/router"
import ArticleImage from "./blocks/article-image"
import ArticleVideo from "./blocks/article-video"
import ArticleContent from "./blocks/article-content"
import TitleContentPoint from "./blocks/title-content-point"
import LatestProject from "./blocks/latest-project"
import CtaExpertise from "./blocks/cta-expertise"
import TeamArchive from "./blocks/team-archive"
import StaffTestimonial from "./blocks/staff-testimonial"
import ThreeColumnContent from "./blocks/three-column-content"
import AvailableRole from "./blocks/available-role"
import ArticleArchive from "./blocks/article-archive"
import ServiceExpertise from "./blocks/service-expertise"
import KeepExploring from "./blocks/keep-exploring"
import ServiceDifference from "./blocks/service-difference"
import Newsletter from "./blocks/newsletter"

/*
* Context for retaining render depth
* */
export const BlockRendererContext = React.createContext(-1)

export const RenderBlock = ({ __typename, ...props }) => {
  switch (__typename.replace("DatoCms", "")) {
    case "Partnership":
      return <Partnership {...props} />
    case "LatestBlock":
      return <LatestBlock {...props} />
    case "TitleContentList":
      return <TitleContentList {...props} />
    case "ImageBanner":
      return <ImageBanner {...props} />
    case "CtaSlider":
      return <CtaSlider {...props} />
    case "TitleContent":
      return <TitleContent {...props} />
    case "LandingBanner":
      return <LandingBanner {...props} />
    case "ProjectArchive":
      return <ProjectArchive {...props} />
    case "AboutBanner":
      return <AboutBanner {...props} />
    case "ValueBlock":
      return <ValueBlock {...props} />
    case "VideoEmbed":
      return <VideoEmbed {...props} />
    case "PageBanner":
      return <PageBanner {...props} />
    case "TitleColumnContent":
      return <TitleColumnContent {...props} />
    case "ThankYou":
      return <ThankYou {...props} />
    case "Contact":
      return <Contact {...props} />
    case "LocationList":
      return <LocationList {...props} />
    case "FeatureInfoBlock":
      return <FeatureInfoBlock {...props} />
    case "Timeline":
      return <Timeline {...props} />
    case "QuoteBlock":
      return <QuoteBlock {...props} />
    case "ArticleImage":
      return <ArticleImage {...props} />
    case "ArticleVideo":
      return <ArticleVideo {...props} />
    case "ArticleContent":
      return <ArticleContent {...props} />
    case "TitleContentPoint":
      return <TitleContentPoint {...props} />
    case "LatestProject":
      return <LatestProject {...props} />
    case "CtaExpertise":
      return <CtaExpertise {...props} />
    case "TeamArchive":
      return <TeamArchive {...props} />
    case "ThreeColumnContent":
      return <ThreeColumnContent {...props} />
    case "StaffTestimonial":
      return <StaffTestimonial {...props} />
    case "AvailableRole":
      return <AvailableRole {...props} />
    case "ArticleArchive":
      return <ArticleArchive {...props} />
    case "ServiceExpertise":
      return <ServiceExpertise {...props} />
    case "KeepExploring":
      return <KeepExploring {...props} />
    case "ServiceDifference":
      return <ServiceDifference {...props} />
    case "Newsletter":
      return <Newsletter {...props} />
    default:
      return <EmptyBlock>{__typename}</EmptyBlock>
  }
}

const BlockRenderer = ({ data, className, brand, slug }) => {
  const { showBlockNames } = useDebug()
  const existingRenderContextDepth = React.useContext(BlockRendererContext)

  return (
    <BlockRendererContext.Provider value={existingRenderContextDepth + 1}>
      {data && data.map((block) => {
        const { __typename: blockType } = block

        if (!blockType) {
          throw new Error("You must source __typename on every blocks field.")
        }

        return (
          <>
            {showBlockNames && (
              <DebugPill style={{
                position: "absolute",
              }}
              >
                {blockType}
              </DebugPill>
            )}
            <RenderBlock
              key={block.id}
              className={className}
              theme={brand}
              slug={slug}
              {...block}
            />
          </>
        )
      })}
    </BlockRendererContext.Provider>
  )
}

export default BlockRenderer
